import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";
import get from "lodash/get";
import { setActionItem, setNotificationMessage } from "../home/action";
import { apiLoader, loaderFlag, multiDealerAdd, selectDealerData, setOwnedBorrowedData, setPopUpMessageData } from "../jobs/action";

import { isEqual } from "app/utils/javascript";
import { getCylinderPayload } from "app/views/pages/Home/Content/Admin/FillCylinders/utils";
import invalidScanner from "assets/images/InvalidScanner.png";
import {
  addNewAdminError,
  addNewAdminJobError,
  addingNewAdmin,
  addingNewAdminJob,
  associateDealer,
  associateUsers,
  certificateDataList,
  certificateWiseStateList,
  cylinderRefDataList,
  editAdminAction,
  getAllAdminsError,
  getCertificate,
  getUser100kg,
  getUserBorrowed,
  getUserLent,
  getUserOwned,
  gettingAllAdmins,
  newAdminAdded,
  newAdminJobAdded,
  set100KgCylinderData,
  setAddUserList,
  setAllAdmins,
  setAllAssociatedDisposalContractor,
  setAllAssociatedRecycleFactory,
  setAllBuilding,
  setAllContractor,
  setAllCustomer,
  setAllDealer,
  setAllDisposalContractor,
  setAllDisposalEngineer,
  setAllFiledEngineer,
  setAllRecycleEngineer,
  setAllRecycleFactory,
  setAllRefrigerant,
  setAllTransportContractor,
  setApiLoader,
  setAssociateDisposer,
  setAssociateProcessor,
  setAssociateRecycler,
  setAssociateTransporterList,
  setChildAssociateContractor,
  setCylinderInfo,
  setDealerList,
  setErrorResponse,
  setFillCylinderList,
  setModelParentList,
  setNew100KGBorrowedCylinder,
  setNew100KGLentCylinder,
  setNonAssociateUsers,
  setParentList,
  setPinCode,
  setReportPinCode,
  setSearchCylinder,
  setSelected100KGCylinder,
  setSelectedCertificate,
  setServiceList,
  setUser100kg,
  setUserBorrowed,
  setUserLent,
  setUserOwned,
  updateUserData,
  updateUserProfile,
  verifyNameError
} from "./action";
import { getFillCylinderList } from "./api";
import {
  ADD_NEW_ADMIN,
  ADD_NEW_ADMIN_JOB,
  ASSOCIATE_USER,
  CYLINDER_REF_MAP,
  DELETE_SELECTED_CYLINDER,
  EDIT_ADMIN_MIDDLEWARE,
  GET_100KG_BORROWED_CYLINDER_DATA,
  GET_100KG_CYLINDER_INFO,
  GET_100KG_LENT_CYLINDER_DATA,
  GET_ADD_USER_LIST,
  GET_ALL_ADMINS,
  GET_ALL_CONTRACTOR_LIST,
  GET_ASSOCIATED_DISPOSAL_CONTRACTOR,
  GET_ASSOCIATED_RECYCLE_FACTORY,
  GET_ASSOCIATE_DISPOSER,
  GET_ASSOCIATE_PROCESSOR,
  GET_ASSOCIATE_RECYCLER,
  GET_BUILDING_DATA,
  GET_CERTIFICATE,
  GET_CHILD_ASSOCIATE_DATA,
  GET_CONTRACTOR_DATA,
  GET_CUSTOMER_DATA,
  GET_CYLINDER_INFO,
  GET_DEALER_DATA,
  GET_DEALER_USER_LIST,
  GET_DISPOSAL_CONTRACTOR_DATA,
  GET_DISPOSAL_ENGINEER_DATA,
  GET_FILED_ENGINEER_DATA,
  GET_NEW_100KG_CYLINDER_DATA,
  GET_NEW_BORROWED_100KG_CYLINDER_DATA,
  GET_NEW_BORROWED_CYLINDER_DATA,
  GET_NEW_OWNED_100KG_CYLINDER_DATA,
  GET_NEW_OWNED_CYLINDER_DATA,
  GET_NON_ASSOCIATE_USERS,
  GET_PARENT_DATA,
  GET_PIN_CODE,
  GET_RATE_CARD_INFO,
  GET_RECYCLE_ENGINEER_DATA,
  GET_RECYCLE_FACTORY_DATA,
  GET_REFRIGERANT_DATA,
  GET_REGION_LIST,
  GET_SERVICES,
  GET_TRANSPORT_CONTRACTOR_DATA,
  GET_USER_100KG,
  GET_USER_20KG,
  GET_USER_BORROWED,
  GET_USER_LENT,
  GET_USER_OWNED,
  SEARCH_GET_CYLINDER_USING_ID,
  SEARCH_MENU_CYLINDER,
  UPDATE_CATEGORY_DATA,
  UPDATE_CERTIFICATE,
  UPDATE_NON_ASSOCIATE_USERS,
  UPDATE_USER_DATA,
  UPDATE_USER_PROFILE,
  VERIFY_NAME
} from "./types";
import { PRODUCT_MANUFACTURER, PRODUCT_MANUFACTURER_USER, SALES_DEPARTMENT, SALES_DEPARTMENT_USER, SALES_OFFICE, SALES_OFFICE_USER } from "app/utils/config";
const { createLogic } = require("redux-logic");

const cylinderRefDataLogic = createLogic({
  type: CYLINDER_REF_MAP,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const obj = {
      authToken,
      contractorId: action?.contractorId
    };

    Service({
      method: "post",
      url: API_ROUTES.CYLINDER_LIST,
      data: obj,
    })
      .then((res) => {
        if (res.data.data) {
          dispatch(cylinderRefDataList(res.data.data.map));
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const associateUser = createLogic({
  type: ASSOCIATE_USER,
  latest: true,
  process({ action }, dispatch, done) {
    const payload = {};
    const authToken = getItem("token");
    payload.associateUser = action.payload.associateUser
    payload.userId = action.payload.userId

    payload.authToken = authToken;
    Service({
      method: "patch",
      url: API_ROUTES.EDITUSER,
      data: payload,
    })
      .then((res) => {
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const addNewAdminLogic = createLogic({
  type: ADD_NEW_ADMIN,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(addingNewAdmin());
    const { formData, payload, msg } = action.payload;
    const { roleID, multiDealerList, multiDealerIndex, modalFlag, entity } = payload;

    Service({
      method: "post",
      url: API_ROUTES.ADDUSER,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setNotificationMessage({ type: "success", message: "userAddedSuccessfully" }))
          dispatch(setPinCode({}))
          dispatch(setReportPinCode({}))
          if (roleID === 6 && entity === "ADD_JOBS") {
            let temp = [...multiDealerList]
            temp[multiDealerIndex] = res?.data?.data?.userInfo
            dispatch(multiDealerAdd(temp))
          }
          if (modalFlag) {
            dispatch(selectDealerData(res?.data?.data?.userInfo))
            dispatch(associateUsers({ associateUser: [res?.data?.data?.userInfo?.id], userId: action.payload.userInfo?.id }))
          } else {
            dispatch(setActionItem(entity, "VIEW"));
            dispatch(newAdminAdded());
          }
        }
        done();
      })
      .catch((err) => {
        dispatch(addNewAdminError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const verifyName = createLogic({
  type: VERIFY_NAME,
  latest: true,
  process({ action }, dispatch, done) {
    const { businessName, name, type } = action.payload;
    const authToken = getItem("token");
    let payload = { authToken, type: type };
    if (name) { payload.name = name; }
    if (businessName) { payload.businessName = businessName; }

    Service({
      method: "post",
      url: API_ROUTES.VERIFY_NAME,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data?.valid) {
          dispatch(verifyNameError(true));
        } else {
          dispatch(verifyNameError(false));
          dispatch(setPopUpMessageData({ modal: true, message: ["cylinderInvalid"] }))
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateCategoryData = createLogic({
  type: UPDATE_CATEGORY_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const payload = action.payload;
    const authToken = getItem("token");
    payload.authToken = authToken;
    const displayMsg = action?.payload?.successMsg
    delete action?.payload?.successMsg;
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_USER_CATEGORY,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(editAdminAction({ isUpdate: true }));
          displayMsg && dispatch(setNotificationMessage({ type: "success", message: "userUpdatedSuccessfully" }))
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateUsersData = createLogic({
  type: UPDATE_USER_DATA,
  latest: true,

  process({ action }, dispatch, done) {
    dispatch(loaderFlag(true))
    Service({
      method: "patch",
      url: API_ROUTES.EDITUSER,
      data: action.payload,
    })
      .then((res) => {
        if (res?.data?.data?.success) {
          dispatch(addingNewAdmin());
          dispatch(setPinCode({}));
          dispatch(setReportPinCode({}))
          !action.isModelClose && dispatch(setNotificationMessage({ type: "success", message: "userUpdatedSuccessfully" }))
          dispatch(editAdminAction({ isUpdate: action.isModelClose ? false : true }));
          dispatch(loaderFlag(false))
        }
        if (res?.data?.error?.errorMsg) {
          dispatch(addNewAdminError(res?.data?.error));
        }
        done();
      })
      .catch((err) => {
        dispatch(addNewAdminError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(loaderFlag(false))
        done();
      });
  },
});

const updateUsersProfileData = createLogic({
  type: UPDATE_USER_PROFILE,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(loaderFlag(true))
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_USER_CONTENT,
      data: action?.payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(loaderFlag(false))
          dispatch(addingNewAdmin());
          dispatch(editAdminAction({ isUpdate: true }));
          action?.displayMsg && dispatch(setNotificationMessage({ type: "success", message: "userUpdatedSuccessfully" }))
          done();
        }
        if (res?.data?.error?.errorMsg) {
          dispatch(addNewAdminError(res?.data?.error));
        }
      })
      .catch((err) => {
        dispatch(addNewAdminError(err));
        dispatch(loaderFlag(false))
        done();
      });
  },
});

const updateAdminLogic = createLogic({
  type: EDIT_ADMIN_MIDDLEWARE,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(addingNewAdmin());
    const formData = new FormData();
    const { profilePic, authToken, removeProfilePic = false, userId, businessOwnerId, businessCertificate, digitalSignature } = action.payload;
    formData.append("authToken", authToken);
    formData.append("userId", userId);

    if (profilePic) {
      formData.append("profilePic", profilePic);
      formData.append("removeProfilePic", removeProfilePic);
    }
    if (businessOwnerId) {
      formData.append("businessOwnerId", businessOwnerId)
    }
    if (businessCertificate) {
      formData.append("businessCertificate", businessCertificate)
    }
    if (digitalSignature) {
      formData.append("digitalSignature", digitalSignature)
    }
    delete action?.payload?.profilePic;
    delete action?.payload?.businessOwnerId;
    delete action?.payload?.businessCertificate;
    delete action?.payload?.digitalSignature;

    if ((profilePic || businessOwnerId || businessCertificate || digitalSignature)) {
      const displayMsg = Object.keys(action?.payload).length > 2 ? false : true
      dispatch(updateUserProfile(formData, displayMsg))
    }


    if (Object.keys(action?.payload).length > 2) {
      delete action?.payload?.removeProfilePic;

      dispatch(updateUserData(action?.payload, action.isModelClose))
    }
  },
});

const getChildAssociateData = createLogic({
  type: GET_CHILD_ASSOCIATE_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(gettingAllAdmins());
    dispatch(setApiLoader(true));
    const authToken = getItem("token");
    const payload = action.payload?.payload;
    payload.authToken = authToken;
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          if (action.payload?.type === "CHILD" || isEqual(action.payload?.userType, "CHILD")) {
            dispatch(setChildAssociateContractor({ type: "child", data: res?.data?.data }))
          } else if (action.payload?.type === "ASSOCIATE") {
            dispatch(setChildAssociateContractor({ type: "associate", data: res?.data?.data }))
          }
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(getAllAdminsError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllAdminsLogic = createLogic({
  type: GET_ALL_ADMINS,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(gettingAllAdmins());
    dispatch(setApiLoader(true));
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      forRoleId: action.payload?.forRoleId,
      roleId: action.payload?.roleId,
      type: action?.payload?.type,
    };
    if (action?.payload?.userId) {
      payload.userId = action?.payload?.userId
    }
    if (action?.payload?.source) {
      payload.source = action?.payload?.source
    }
    if (action?.payload?.jobType) {
      payload.jobType = action?.payload?.jobType
    }
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload?.page),
      data: payload,
    })
      .then((res) => {
        const allAdminData = get(res, "data.data", {});
        if (action.payload?.forRoleId === 6 && action?.payload?.type === "ASSOCIATE") {
          dispatch(associateDealer(res?.data?.data));
        } else {
          dispatch(
            setAllAdmins({
              ...allAdminData,
              requestedPage: action.payload,
            })
          );
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(getAllAdminsError(err));
        dispatch(setApiLoader(false));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getDealerListData = createLogic({
  type: GET_DEALER_USER_LIST,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload?.pageNo),
      data: action?.payload?.payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setDealerList(res?.data?.data));
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getParentData = createLogic({
  type: GET_PARENT_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      ...action.payload
    };
    Service({
      method: "post",
      url: API_ROUTES.GET_PARENT_DATA,
      data: payload,
    })
      .then((res) => {
        if (action?.payload?.model) {
          dispatch(setModelParentList(res?.data?.data))
        } else {
          dispatch(setParentList(res?.data?.data))
        }
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const addNewAdminJobLogic = createLogic({
  type: ADD_NEW_ADMIN_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(addingNewAdminJob());
    const token = getItem("token");
    // axios.post(API_ROUTES.ADD_JOB, {
    //     ...action.payload,
    //     authToken: token,
    // });
    Service({
      method: "post",
      url: API_ROUTES.ADD_JOB,
      data: {
        ...action.payload,
        authToken: token,
      },
    })
      .then(() => {
        dispatch(newAdminJobAdded());
        dispatch(setNotificationMessage({ type: "success", message: "jobCreateSuccessfully" }))
        done();
      })
      .catch((err) => {
        dispatch(addNewAdminJobError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getAllDealerLogic = createLogic({
  type: GET_DEALER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload.payload
    payload.authToken = authToken
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload.page),
      data: payload,
    })
      .then((res) => {
        const allDealerData = get(res, "data.data", {});

        dispatch(
          setAllDealer({
            ...allDealerData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllRecycleFactoryLogic = createLogic({
  type: GET_RECYCLE_FACTORY_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 8,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allRecycleFactoryData = get(res, "data.data", {});
        dispatch(
          setAllRecycleFactory({
            ...allRecycleFactoryData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));

        done();
      });
  },
});

const getAllDisposalContractorLogic = createLogic({
  type: GET_DISPOSAL_CONTRACTOR_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 14,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allTransportData = get(res, "data.data", {});
        dispatch(
          setAllDisposalContractor({
            ...allTransportData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllTransportContractorLogic = createLogic({
  type: GET_TRANSPORT_CONTRACTOR_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const { userType, forRoleId, roleId, userId, page, associateData } = action.payload
    const payload = {
      authToken: authToken ? authToken : "",
      type: userType,
      forRoleId: forRoleId,
      roleId: roleId,
    };
    if (userId) {
      payload.userId = userId
    }
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(page),
      data: { ...payload },
    })
      .then((res) => {
        const allTransportData = get(res, "data.data", {});
        if (associateData) {
          dispatch(setAssociateTransporterList({ ...allTransportData, requestedPage: page, }));
        } else {
          dispatch(setAllTransportContractor({ ...allTransportData, requestedPage: page, }));
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllBuildingLogic = createLogic({
  type: GET_BUILDING_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");

    let payload = {
      authToken: authToken ? authToken : "",
      userId: action?.payload?.userId,
      customerId: action?.payload?.customerId,
    };
    if (action?.payload?.source) {
      payload.source = action?.payload?.source
    }
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_USER_BUILDING(action.payload?.pageNo || 1),
      data: payload,
    })
      .then((res) => {
        const allBuildingData = get(res, "data.data", {});
        dispatch(
          setAllBuilding({
            ...allBuildingData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllRefrigerantLogic = createLogic({
  type: GET_REFRIGERANT_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 9,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allRefrigerantData = get(res, "data.data", {});
        dispatch(
          setAllRefrigerant({
            ...allRefrigerantData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllContractorLogic = createLogic({
  type: GET_CONTRACTOR_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 7,
      userId: action?.dataId,
      roleId: 7,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allContractorData = get(res, "data.data", {});
        dispatch(
          setAllContractor({
            ...allContractorData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllCustomerLogic = createLogic({
  type: GET_CUSTOMER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 12,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allCustomerData = get(res, "data.data", {});
        dispatch(
          setAllCustomer({
            ...allCustomerData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllFiledEngineerLogic = createLogic({
  type: GET_FILED_ENGINEER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 11,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allFiledEngineerData = get(res, "data.data", {});
        dispatch(
          setAllFiledEngineer({
            ...allFiledEngineerData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllRecycleEngineerLogic = createLogic({
  type: GET_RECYCLE_ENGINEER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 13,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allRecycleEngineerData = get(res, "data.data", {});
        dispatch(
          setAllRecycleEngineer({
            ...allRecycleEngineerData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllDisposalEngineerLogic = createLogic({
  type: GET_DISPOSAL_ENGINEER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "CHILD",
      forRoleId: 15,
      userId: action.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allDisposalEngineerData = get(res, "data.data", {});
        dispatch(
          setAllDisposalEngineer({
            ...allDisposalEngineerData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllAssociatedRecycleFactory = createLogic({
  type: GET_ASSOCIATED_RECYCLE_FACTORY,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = {
      authToken: authToken ? authToken : "",
      type: "ASSOCIATE",
      forRoleId: 8,
    };
    if (action?.jobTypeName) {
      payload.jobType = action?.jobTypeName
    }
    if (action?.dataId) {
      payload.userId = action?.dataId
    }
    if (action?.roleId) {
      payload.roleId = action?.roleId
    }
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload),
      data: payload,
    })
      .then((res) => {
        const allAssociatedRecycleFactoryData = get(res, "data.data", {});
        dispatch(
          setAllAssociatedRecycleFactory({
            ...allAssociatedRecycleFactoryData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllAssociatedDisposalContractor = createLogic({
  type: GET_ASSOCIATED_DISPOSAL_CONTRACTOR,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "ASSOCIATE",
      forRoleId: action.payload?.forRoleId,
      userId: action.payload?.dataId,
    };
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload.pageNo),
      data: { ...payload },
    })
      .then((res) => {
        const allAssociatedDisposalContractorData = get(res, "data.data", {});
        dispatch(
          setAllAssociatedDisposalContractor({
            ...allAssociatedDisposalContractorData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAllUserOwnedLogic = createLogic({
  type: GET_USER_OWNED,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      state: "OWNED",
      cylinderType: "RECOVERY"
    };
    if (action?.dataId) {
      payload.userId = action?.dataId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_USER_TOOLS(action.payload),
      data: payload,
    })
      .then((res) => {
        const allUserOwnedData = get(res, "data.data", {});
        dispatch(
          setUserOwned({
            ...allUserOwnedData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const getAllUserBorrowedLogic = createLogic({
  type: GET_USER_BORROWED,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.payload) {
      payload = { ...payload, ...action.payload?.payload }
    }
    if (action?.dataId) {
      payload.userId = action?.dataId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_USER_TOOLS(action.payload?.pageNo),
      data: { ...payload },
    })
      .then((res) => {
        if (res?.data?.data) {
          const { cylinderType, state } = action.payload?.payload
          if (cylinderType === "RECOVERY") {
            const allUserBorrowedData = get(res, "data.data", {});
            dispatch(
              setUserBorrowed({
                ...allUserBorrowedData,
                requestedPage: action.payload,
              })
            );
          }
          if (cylinderType === "TRANSFER" && state === "BORROWED") {
            dispatch(setNew100KGBorrowedCylinder(res?.data?.data))
          }
          if (cylinderType === "TRANSFER" && state === "LENT") {
            dispatch(setNew100KGLentCylinder(res?.data?.data))
          }
        }
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const getAllUserLentLogic = createLogic({
  type: GET_USER_LENT,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      state: "LENT",
      cylinderType: "RECOVERY"
    };
    if (action?.dataId) {
      payload.userId = action?.dataId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_USER_TOOLS(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allUserLentData = get(res, "data.data", {});
        dispatch(
          setUserLent({
            ...allUserLentData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const getAllUser100KgLogic = createLogic({
  type: GET_USER_100KG,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      state: "OWNED",
      cylinderType: "TRANSFER"
    };
    if (action?.dataId) {
      payload.userId = action?.dataId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_USER_TOOLS(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const allUser100KgData = get(res, "data.data", {});
        dispatch(
          setUser100kg({
            ...allUser100KgData,
            requestedPage: action.payload,
          })
        );
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setApiLoader(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getAllUser20KgLogic = createLogic({
  type: GET_USER_20KG,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "20Kg",
      // forRoleId: 15,
      // userId: action.dataId,
    };
    // Service({
    //   method: "post",
    //   url: API_ROUTES.GET_USER_TOOLS(action.payload),
    //   data: { ...payload },
    // })
    //   .then((res) => {
    //     const allUser20KgData = get(res, "data.data", {});
    //     dispatch(
    //       setUser20kg({
    //         ...allUser20KgData,
    //         requestedPage: action.payload,
    //       })
    //     );
    //     done();
    //   })
    //   .catch((err) => {
    //     //dispatch(getAllCustomersError(err));
    //     dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
    //     done();
    //   });
  },
});

const getPinCode = createLogic({
  type: GET_PIN_CODE,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      pincode: action.payload?.payload,
    };
    Service({
      method: "post",
      url: API_ROUTES.GET_PIN_CODE,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          const allPinCode = get(res, "data.data", {});
          if (action?.payload?.report) {
            dispatch(setReportPinCode({ ...allPinCode, requestedPage: action.payload?.payload }))
          } else {
            dispatch(setPinCode({ ...allPinCode, requestedPage: action.payload?.payload, })
            );
          }
        } else if (res?.data?.error) {
          if (action?.payload?.report) {
            dispatch(setReportPinCode({}))
          } else {
            dispatch(setPinCode({}))
          }
        }
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getNewOwnedCylinderDataLogic = createLogic({
  type: GET_NEW_OWNED_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.jobId) {
      payload.jobId = action.payload.jobId
    } else {
      payload.jobType = action.payload.jobType
    }
    if (action.payload?.state) {
      payload.state = action.payload.state
    }
    if (action.payload?.type) {
      payload.type = action.payload.type
    }
    if (action.payload?.cylinderType) {
      payload.cylinderType = action.payload.cylinderType
    }
    if (action.payload?.processType) {
      payload.processType = action.payload.processType
    }
    if (action.payload?.pagination) {
      payload.pagination = false
    }
    if (action.payload?.currentJobId) {
      payload.currentJobId = action.payload.currentJobId
    }
    if (action.payload?.currentEquipmentId) {
      payload.currentEquipmentId = action.payload.currentEquipmentId
    }
    if (action.payload?.userId) {
      payload.userId = action.payload?.userId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        const allUserOwnedData = get(res, "data.data", {});
        const type = action.payload?.type
        if (Object.keys(allUserOwnedData).length) {
          if (action.payload?.pagination) {
            if (type === "TRANSFER") {
              dispatch(setOwnedBorrowedData({ kg100Cylinder: res?.data?.data?.list }))
            } else {
              dispatch(setOwnedBorrowedData({ ownedCylinder: res?.data?.data?.list }))
            }
          } else {
            dispatch(
              setUserOwned({
                ...allUserOwnedData,
                requestedPage: action.payload.pageNo,
              })
            );
          }
        }
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});
const getNewOwned100KgCylinderDataLogic = createLogic({
  type: GET_NEW_OWNED_100KG_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.jobId) {
      payload.jobId = action.payload.jobId
    } else {
      payload.jobType = action.payload.jobType
    }
    if (action.payload?.state) {
      payload.state = action.payload.state
    }
    if (action.payload?.type) {
      payload.type = action.payload.type
    }
    if (action.payload?.cylinderType) {
      payload.cylinderType = action.payload.cylinderType
    }
    if (action.payload?.processType) {
      payload.processType = action.payload.processType
    }
    if (action.payload?.pagination) {
      payload.pagination = false
    }
    if (action.payload?.currentJobId) {
      payload.currentJobId = action.payload.currentJobId
    }
    if (action.payload?.currentEquipmentId) {
      payload.currentEquipmentId = action.payload.currentEquipmentId
    }
    if (action.payload?.userId) {
      payload.userId = action.payload?.userId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        const allUserOwnedData = get(res, "data.data", {});
        if (action.payload?.pagination) {
          dispatch(setOwnedBorrowedData({ kg100Cylinder: res?.data?.data?.list }))
        } else {
          dispatch(
            setUserOwned({
              ...allUserOwnedData,
              requestedPage: action.payload.pageNo,
            })
          );
        }

        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});
const getNewBorrowed100KgCylinderDataLogic = createLogic({
  type: GET_NEW_BORROWED_100KG_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.jobId) {
      payload.jobId = action.payload.jobId
    } else {
      payload.jobType = action.payload.jobType
    }
    if (action.payload?.state) {
      payload.state = action.payload.state
    }
    if (action.payload?.type) {
      payload.type = action.payload.type
    }
    if (action.payload?.cylinderType) {
      payload.cylinderType = action.payload.cylinderType
    }
    if (action.payload?.processType) {
      payload.processType = action.payload.processType
    }
    if (action.payload?.pagination) {
      payload.pagination = false
    }
    if (action.payload?.currentJobId) {
      payload.currentJobId = action.payload.currentJobId
    }
    if (action.payload?.currentEquipmentId) {
      payload.currentEquipmentId = action.payload.currentEquipmentId
    }
    if (action.payload?.userId) {
      payload.userId = action.payload?.userId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        const allUserOwnedData = get(res, "data.data", {});
        if (action.payload?.pagination) {
          dispatch(setOwnedBorrowedData({ borrowed100kgCylinder: res?.data?.data?.list }))
        } else {
          dispatch(
            setUserOwned({
              ...allUserOwnedData,
              requestedPage: action.payload.pageNo,
            })
          );
        }

        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const getNew100KGCylinderDataLogic = createLogic({
  type: GET_NEW_100KG_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = {
      authToken: authToken ? authToken : "",
      // type: "100Kg",
    };
    if (action?.payload?.payload) {
      payload = { ...payload, ...action.payload.payload }
    }

    // if (action.payload?.processType) {
    //   payload.processType = action.payload.processType
    // }
    // if (action.payload?.currentCylinderId) {
    //   payload.currentCylinderId = action.payload.currentCylinderId
    // }
    // if (action.payload?.currentJobId) {
    //   payload.currentJobId = action.payload.currentJobId
    // }
    // if (action.payload?.pagination) {
    //   payload.pagination = false
    // }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        const allUser100KgData = get(res, "data.data", {});
        if (action.payload?.pagination) {
          dispatch(setSelected100KGCylinder(res?.data?.data?.list))
        }
        dispatch(setUser100kg({
          ...allUser100KgData,
          requestedPage: action.payload,
        })
        );
        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const getNewBorrowedCylinderDataLogic = createLogic({
  type: GET_NEW_BORROWED_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.jobId) {
      payload.jobId = action.payload.jobId
    } else {
      payload.jobType = action.payload.jobType
    }
    if (action.payload?.state) {
      payload.state = action.payload.state
    }
    if (action.payload?.type) {
      payload.type = action.payload.type
    }
    if (action.payload?.cylinderType) {
      payload.cylinderType = action.payload.cylinderType
    }
    if (action.payload?.processType) {
      payload.processType = action.payload.processType
    }
    if (action.payload?.pagination) {
      payload.pagination = false
    }
    if (action.payload?.currentJobId) {
      payload.currentJobId = action.payload.currentJobId
    }
    if (action.payload?.currentEquipmentId) {
      payload.currentEquipmentId = action.payload.currentEquipmentId
    }
    if (action.payload?.userId) {
      payload.userId = action.payload?.userId
    }
    if (action.payload?.excludeJobId) {
      payload.excludeJobId = action.payload?.excludeJobId
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        const allUserBorrowedData = get(res, "data.data", {});
        if (action.payload?.pagination) {
          dispatch(setOwnedBorrowedData({ borrowedCylinder: res?.data?.data?.list }))
        } else {
          dispatch(
            setUserBorrowed({
              ...allUserBorrowedData,
              requestedPage: action.payload.pageNo,
            })
          );
        }
        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
      }).finally(() => { done() });
  },
});

const get100KGBorrowedCylinder = createLogic({
  type: GET_100KG_BORROWED_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.payload) {
      payload = { ...payload, ...action?.payload?.payload }
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action?.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        if (action.payload?.pagination) {
          dispatch(setOwnedBorrowedData({ borrowedCylinder: res?.data?.data?.list }))
        }
        if (res?.data?.data?.list) {
          dispatch(setNew100KGBorrowedCylinder(res?.data?.data))
        }
        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const get100KGLentCylinder = createLogic({
  type: GET_100KG_LENT_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = {
      authToken: authToken ? authToken : "",
    };
    if (action.payload?.payload) {
      payload = { ...payload, ...action?.payload?.payload }
    }
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_NEW_CYLINDER(action?.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        // if (action.payload?.pagination) {
        //   dispatch(setOwnedBorrowedData({ borrowedCylinder: res?.data?.data?.list }))
        // }
        if (res?.data?.data?.list) {
          dispatch(setNew100KGLentCylinder(res?.data?.data))
        }
        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const getCylinderInfoById = createLogic({
  type: SEARCH_GET_CYLINDER_USING_ID,
  process({ action, getState }, dispatch, done) {
    const stateData = getState();
    const jobType = stateData.jobs.jobType;

    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      ...(action?.payload?.cylinderTag && { cylinderTag: action?.payload?.cylinderTag }),
      ...(action?.payload?.name && { name: action?.payload?.name }),
      ...(action?.payload?.contractorId && { contractorId: action?.payload?.contractorId })
    };

    if (action?.payload?.type) {
      payload.type = action?.payload?.type
    }
    if (action?.payload?.jobId) {
      payload.jobId = action?.payload?.jobId
    }
    if (action?.payload?.judgement) {
      payload.judgement = action?.payload?.judgement
    }
    if (action?.payload?.cylinderType) {
      payload.cylinderType = action?.payload?.cylinderType
    }
    if (action?.payload?.cylinderId) {
      payload.cylinderId = action?.payload?.cylinderId
    }
    if (action?.payload?.jobType) {
      payload.jobType = action?.payload?.jobType
    }
    if (action?.payload?.state) {
      payload.state = action?.payload?.state
    }
    if (action?.payload?.processType) {
      payload.processType = action?.payload?.processType
    }
    if (action?.payload?.currentJobId) {
      payload.currentJobId = action?.payload?.currentJobId
    }
    if (action?.payload?.currentEquipmentId) {
      payload.currentEquipmentId = action?.payload?.currentEquipmentId
    }
    if (action?.payload?.userId) {
      payload.userId = action?.payload?.userId
    }
    if (action?.payload?.currentCylinderId) {
      payload.currentCylinderId = action?.payload?.currentCylinderId
    }
    if (action?.payload?.excludeJobId) {
      payload.excludeJobId = action?.payload?.excludeJobId
    }
    if (action?.payload?.cylinderType) {
      payload.cylinderType = action?.payload?.cylinderType
    }
    if (action?.payload?.allRefrigerantType) {
      payload.allRefrigerantType = action?.payload?.allRefrigerantType
    }
    if (action?.payload?.lotId) {
      payload.lotId = action?.payload?.lotId
    }
    Service({
      method: "post",
      url: API_ROUTES.GET_CYLINDER_BY_ID(action?.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        if (res.status === 200) {
          if (!action?.payload?.hideSearch && res?.data?.data?.list && res?.data?.data?.list.length === 0) {
            if(jobType !== "recover") {
              dispatch(setPopUpMessageData({ modal: true, icons: [invalidScanner], message: ["invalidSearch"] }))
            }
          }
          dispatch(
            setSearchCylinder({
              res: res?.data?.data,
              type: action?.payload?.searchCylinderName,
            })
          );
        }
        done();
      })
      .catch((err) => {
        // dispatch(getAllJobsError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getMenuCylinderInfoById = createLogic({
  type: SEARCH_MENU_CYLINDER,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const { state, cylinderType, userId, cylinderTag, hideSearch = false } = action.payload
    const payload = {
      authToken: authToken ? authToken : "",
      cylinderName: action?.payload?.cylinderName,
      ...(cylinderTag && { cylinderTag })
    };
    if (state) {
      payload.state = state
    } if (cylinderType) {
      payload.cylinderType = cylinderType
    }
    if (userId) {
      payload.userId = userId
    }

    Service({
      method: "post",
      url: API_ROUTES.SEARCH_MENU_CYLINDER(action?.payload?.page),
      data: payload,
    })
      .then((res) => {
        if (res.status === 200) {
          const { cylinderStatus, state, cylinderType } = action.payload
          if (res?.data?.data?.list && res?.data?.data?.list.length === 0) {
            if (!hideSearch) {
              dispatch(setPopUpMessageData({ modal: true, icons: [invalidScanner], message: ["invalidSearch"] }))
            }
          }
          if (cylinderStatus === "FILLED" && state === "OWNED") {
            dispatch(setFillCylinderList(res?.data?.data, "filledList"))
          }
          if (cylinderType === "FILL" && state === "BORROWED") {
            dispatch(setFillCylinderList(res?.data?.data, "fillBorrowedList"))
          }
          if (cylinderStatus === "EMPTY" && state === "OWNED") {
            dispatch(setFillCylinderList(res?.data?.data, "fillEmptyList"))
          }
          if (cylinderType === "FILL" && state === "LENT") {
            dispatch(setFillCylinderList(res?.data?.data, "fillGivenOutList"))
          }
          if (action.payload.state === "LENT" && action.payload.cylinderType === "TRANSFER") {
            dispatch(setNew100KGLentCylinder(res?.data?.data))
          } else {
            dispatch(setSearchCylinder({
              res: res?.data?.data,
              type: action?.payload?.type ? action?.payload?.type : action?.payload?.GetSearchCylinder,
            }));
          }
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getCylinderInfoLogic = createLogic({
  type: GET_CYLINDER_INFO,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      refrigerantType: action?.payload?.refrigerantType || "",
    }
    Service({
      method: "post",
      url: API_ROUTES.CYLINDER_INFO_API,
      data: { ...payload },
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setCylinderInfo(res?.data?.data));
        }
        done();
      })
      .catch((err) => {
        // dispatch(getAllJobsError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const get100KgCylinder = createLogic({
  type: GET_100KG_CYLINDER_INFO,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      type: "100Kg",
      userId: action?.payload?.id,
      processType: action?.payload?.type
    };
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_100KG_CYLINDER(action.payload?.pageNo),
      data: { ...payload },
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(set100KgCylinderData(res?.data?.data));
        }
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        dispatch(setApiLoader(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getCertificateLogic = createLogic({
  type: GET_CERTIFICATE,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(apiLoader(true));
    const authToken = getItem("token");
    const payload = action.payload;
    payload.authToken = authToken ? authToken : "";
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_CERTIFICATE_API,
      data: payload,
    })
      .then((res) => {
        if (res.status === 200) {
          const allCertificatesData = get(res, "data.data", {});
          dispatch(certificateDataList({ ...allCertificatesData }));
        }
        dispatch(apiLoader(false));
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getRateCardInfo = createLogic({
  type: GET_RATE_CARD_INFO,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = action.payload;
    payload.authToken = authToken ? authToken : "";
    // Service({
    //   method: "post",
    //   url: API_ROUTES.GET_RATE_CARD_API,
    //   data: payload,
    // })
    //   .then((res) => {
    //     dispatch(setRateCardDetails(res?.data?.data))
    //     done();
    //   })
    //   .catch((err) => {
    //     dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
    done();
    //   });
  },
});

const getServiceLogic = createLogic({
  type: GET_SERVICES,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = action.payload;
    payload.authToken = authToken ? authToken : "";
    Service({
      method: "post",
      url: API_ROUTES.GET_SERVICE_API,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setServiceList(res?.data?.data))
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateCertificate = createLogic({
  type: UPDATE_CERTIFICATE,
  latest: true,
  process({ action }, dispatch, done) {
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_CERTIFICATE_URL,
      data: action.payload.payload,
    })
      .then((res) => {
        if (res?.data?.data?.success) {
          dispatch(setNotificationMessage({ type: "success", message: "certificateUpdatedSuccessfully" }));

          dispatch(getCertificate({ certificateId: action.payload.certificateKey }));
          dispatch(setActionItem("CERTIFICATION", "VIEW"));
          dispatch(setSelectedCertificate({}));
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getRegionList = createLogic({
  type: GET_REGION_LIST,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = action.payload.payload;
    payload.authToken = authToken;
    Service({
      method: "post",
      url: API_ROUTES.GET_CERTIFICATE_WISE_STATE,
      data: payload,
    })
      .then((res) => {
        dispatch(certificateWiseStateList(res?.data?.data || []));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getContractorList = createLogic({
  type: GET_ALL_CONTRACTOR_LIST,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      roleId: action?.payload?.roleId,
    };
    Service({
      method: "post",
      url: API_ROUTES.GET_CONTRACTOR_LIST(action?.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        const allContractorData = get(res, "data.data", {});
        dispatch(
          setAllContractor({
            ...allContractorData,
            requestedPage: action.payload,
          })
        );
        done();
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getAddUserListData = createLogic({
  type: GET_ADD_USER_LIST,
  latest: true,
  process({ getState, action }, dispatch, done) {
    const loginUserData = getState()?.user?.personalInfo
    const authToken = getItem("token");
    const payload = action.payload?.payload;
    payload.authToken = authToken;
    //child user role condition
    const childParentRole = {
      [PRODUCT_MANUFACTURER_USER]: PRODUCT_MANUFACTURER,
      [SALES_DEPARTMENT_USER]: SALES_DEPARTMENT,
      [SALES_OFFICE_USER]: SALES_OFFICE,
    }
    if ([PRODUCT_MANUFACTURER_USER, SALES_DEPARTMENT_USER, SALES_OFFICE_USER].includes(loginUserData?.roleId) && (!isEqual(childParentRole[loginUserData?.roleId], payload?.roleId))) {
      payload.userId = loginUserData.adminId
    }
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action?.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        dispatch(setAddUserList(res?.data?.data));
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getNonAssociateData = createLogic({
  type: GET_NON_ASSOCIATE_USERS,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action?.payload?.pageNo),
      data: action.payload?.payload,
    })
      .then((res) => {
        dispatch(setNonAssociateUsers(res?.data?.data));
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const updateNonAssociateData = createLogic({
  type: UPDATE_NON_ASSOCIATE_USERS,
  latest: true,
  process({ action }, dispatch, done) {

    dispatch(setApiLoader(true))
    Service({
      method: "patch",
      url: API_ROUTES.EDITUSER,
      data: action.payload?.payload,
    })
      .then((res) => {
        dispatch(setApiLoader(false));
        dispatch(setErrorResponse({ response: true }));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setErrorResponse({ error: true }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAssociateProcessorList = createLogic({
  type: GET_ASSOCIATE_PROCESSOR,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload?.pageNo),
      data: action.payload?.payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setAssociateProcessor(res?.data?.data))
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAssociateRecyclerList = createLogic({
  type: GET_ASSOCIATE_RECYCLER,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload?.pageNo),
      data: action.payload?.payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setAssociateRecycler(res?.data?.data))
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const getAssociateDisposerList = createLogic({
  type: GET_ASSOCIATE_DISPOSER,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(setApiLoader(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_DEALER(action.payload?.pageNo),
      data: action.payload?.payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setAssociateDisposer(res?.data?.data))
        }
        dispatch(setApiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false));
        done();
      });
  },
});

const deleteCylinder = createLogic({
  type: DELETE_SELECTED_CYLINDER,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = { authToken, ...action.payload?.payload }
    Service({
      method: "delete",
      url: API_ROUTES.EDIT_CYLINDER,
      data: payload,
    })
      .then(async (res) => {
        if (res?.data?.data?.success) {
          dispatch(setNotificationMessage({ type: "success", message: action?.payload?.successMsg }));
          switch (action.payload?.cylinderType) {
            case "OWNED":
              if (isEqual(action.payload?.capacity, "FILL")) {
                const fillPayload = getCylinderPayload({ cylinderStatus: action?.payload?.fillType, cylinderType: "FILL", state: "OWNED" })
                const response = await getFillCylinderList({ pageNo: action.payload?.pageNo, payload: fillPayload })
                if (response?.data?.data) {
                  dispatch(setFillCylinderList(response?.data?.data, "fillEmptyList"))
                }
                return null
              } else {
                return dispatch(getUserOwned(action.payload?.pageNo));
              }
            case "BORROWED":
              if (action.payload?.capacity === "20Kg") {
                return dispatch(getUserBorrowed({ pageNo: action.payload?.pageNo, payload: { state: "BORROWED", cylinderType: "RECOVERY" } }));
              } else {
                return dispatch(getUserBorrowed({ pageNo: action.payload?.pageNo, payload: { state: "BORROWED", cylinderType: "TRANSFER" } }));
              }
            case "LENT":
              if (action.payload?.capacity === "20Kg") {
                return dispatch(getUserLent(action.payload?.pageNo));
              } else {
                return dispatch(getUserBorrowed({ pageNo: action.payload?.pageNo, payload: { state: "LENT", cylinderType: "TRANSFER" } }));
              }
            case "100Kg":
              return dispatch(getUser100kg(action.payload?.pageNo));
            default:
              break;
          }
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

export default [
  addNewAdminLogic,
  associateUser,
  getAllAdminsLogic,
  getChildAssociateData,
  addNewAdminJobLogic,
  updateAdminLogic,
  getAllDealerLogic,
  getDealerListData,
  getAllRecycleFactoryLogic,
  getAllDisposalContractorLogic,
  getAllTransportContractorLogic,
  getAllRefrigerantLogic,
  getAllContractorLogic,
  getAllCustomerLogic,
  getAllFiledEngineerLogic,
  getAllRecycleEngineerLogic,
  getAllDisposalEngineerLogic,
  getAllUserOwnedLogic,
  getAllUserBorrowedLogic,
  get100KGBorrowedCylinder,
  getAllUserLentLogic,
  getAllUser100KgLogic,
  verifyName,
  getAllUser20KgLogic,
  getPinCode,
  getAllAssociatedRecycleFactory,
  getAllBuildingLogic,
  getAllAssociatedDisposalContractor,
  getNewOwnedCylinderDataLogic,
  getNewBorrowedCylinderDataLogic,
  getNew100KGCylinderDataLogic,
  getCylinderInfoById,
  getCylinderInfoLogic,
  get100KgCylinder,
  cylinderRefDataLogic,
  getCertificateLogic,
  getServiceLogic,
  getRateCardInfo,
  updateCertificate,
  getContractorList,
  getParentData,
  updateCategoryData,
  updateUsersProfileData,
  updateUsersData,
  getRegionList,
  getAddUserListData,
  getMenuCylinderInfoById,
  get100KGLentCylinder,
  getNonAssociateData,
  updateNonAssociateData,
  getAssociateProcessorList,
  getAssociateRecyclerList,
  getAssociateDisposerList,
  deleteCylinder,
  getNewBorrowed100KgCylinderDataLogic,
  getNewOwned100KgCylinderDataLogic
];